import React from 'react';

import {IContentCardContentfulProps} from './IContentCardContentful';
import {ContentCardRenderer} from './Subcomponents';

const ContentCardContentful = (props: IContentCardContentfulProps) => {
	return <ContentCardRenderer {...props} />;
};

export default ContentCardContentful;
